import React from 'react';

import {STATUS_ICONS} from 'benchling-apps/end-user-page/activity/BenchlingAppSessionStatusCell';
import {BenchlingAppSessionStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FilterKey, MultiValueFilter} from 'search/SearchConstants';
import pick from 'util/pick';

import DropdownFilterForm from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface SessionStatusFilter extends MultiValueFilter {
  key: FilterKey.SESSION_STATUS;
}

interface Props extends BaseFilterFormProps {
  filter: SessionStatusFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SessionStatusFilter) => void;
  onRemove?: () => void;
}

const SessionStatusFilterForm: React.SFC<Props> = (props: Props): JSX.Element => {
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      isMulti={true}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={Object.keys(BenchlingAppSessionStatus).map((status: BenchlingAppSessionStatus) => ({
        name: STATUS_ICONS[status].label,
        value: status,
      }))}
      value={props.filter.value}
    />
  );
};

export default SessionStatusFilterForm;
